<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <install-prompt></install-prompt>
          <h2 class="title" style="margin-bottom: 30px" color>
            {{ $t("lottery.mainPage.title") }}
          </h2>
          <base-modal
            :title="modalTitle"
            :message="modalMessage"
            :showModal="showModal"
            @close-modal="showModal = false"
          />
          <div>
            <div id="body">
              <div v-if="!configuringLottery">
                <div class="center col-12">
                  <h4 style="margin-bottom: 10px" class="title card-title">
                    {{ $t("lottery.mainPage.subtitle") }}
                  </h4>
                  <div class="center" style="width:100%">
                    <base-timer
                      :key="timerKey"
                      :time-limit="timeLeft"
                      @timeIsUp="timeIsUp"
                    />
                  </div>
                  <br />
                  <div style="text-align:center;">
                    <a href="#" @click="configuringLottery = true">
                      <u style="color:white;">{{
                        $t("lottery.mainPage.configLink")
                      }}</u>
                    </a>
                  </div>
                  <div style="text-align:center;">
                    <a href="#" @click="clearLotteryTime(); configuringLottery = true">
                      <u style="color:white;">{{
                        $t("lottery.mainPage.stopLotteryLink")
                      }}</u>
                    </a>
                  </div>
                  <custom-table
                    :columns="[
                      {
                        title: $t('lottery.mainPage.tableHeader'),
                        name: 'text',
                      },
                    ]"
                    :data="members"
                  />
                </div>
              </div>
              <div v-else>
                <h4 style="margin-bottom: 10px" class="title">
                  {{ $t("lottery.configPage.subtitle") }}
                </h4>
                <p class="float-left" style="display:contents">
                  {{ $t("lottery.configPage.inputTimeLabel") }}
                </p>
                <base-input
                  type="text"
                  :placeholder="$t('lottery.configPage.inputTimePlaceholder')"
                  v-model="lotteryTime"
                ></base-input>
                <p class="float-left" style="display:contents">
                  {{ $t("lottery.configPage.inputMemberLabel") }}
                </p>
                <br />
                <input-list v-model="members" :config="listConfig" />
                <button
                  class="btn btn-base btn-fill float-right"
                  @click="saveLotterySettings"
                >
                  {{ $t("lottery.configPage.saveButton") }}
                </button>
              </div>
            </div>
          </div>
          <div slot="footer" style="width: 100%">
            <share-footer />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from "src/mixin";

import ShareFooter from "src/components/ShareFooter.vue";
import LotteryTimer from "src/components/PartyDashboard/LotteryTimer.vue";
import InputList from "src/components/InputList.vue";
import CustomTable from "src/components/CustomTable.vue";
import BaseTimer from "src/components/Timer/BaseTimer.vue";

export default {
  mixins: [mixin],
  components: {
    BaseTimer,
    ShareFooter,
    LotteryTimer,
    InputList,
    CustomTable,
  },
  data() {
    return {
      tabIsVisible: true,

      // Lottery and Wheel modal
      members: [],
      timeLeft: 0,
      listConfig: {
        placeholder: this.$t("lottery.configPage.inputMemberPlaceholder"),
      },
      lotteryStarted: false,
      configuringLottery: false,
      lotteryTime: localStorage.lotteryTime
        ? parseInt(localStorage.lotteryTime) / 60000
        : 10,
      timerKey: 0,
    };
  },

  created() {
    this.checkLotteryStarted();
    window.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        this.tabIsVisible = true;
      } else {
        this.tabIsVisible = false;
      }
    });
  },

  watch: {
    members: {
      deep: true,
      handler() {
        // Fix index and color for each element inside wheelOptions
        this.members.forEach(function(el, i) {
          el.id = i + 1;
        });
      },
    },
  },

  methods: {
    clearLotteryTime(){
      localStorage.removeItem('lotteryTime');
    },
    checkLocalStorage() {
      if (localStorage.lotteryTime) {
        return true;
      }
      return false;
    },
    checkLotteryStarted() {
      const localStorageIsSetted = this.checkLocalStorage();
      if (!localStorageIsSetted) {
        this.configuringLottery = true;
        return;
      }

      this.members = JSON.parse(localStorage.members);
      const currentTime = parseInt(Date.now());
      const lastLotteryTime = parseInt(localStorage.lastLotteryTime);
      const lotteryTime = parseInt(localStorage.lotteryTime);
      const nextLotteryTime = parseInt(lastLotteryTime + lotteryTime);
      if (currentTime > nextLotteryTime + lotteryTime * 3) {
        this.lotteryStarted = false;
        this.configuringLottery = true;
      } else {
        this.lotteryStarted = true;
        this.timeLeft = Math.floor((nextLotteryTime - currentTime) / 1000);
      }
    },
    saveLotterySettings() {
      if (this.validateLotteryConfigFields()) {
        if (this.members[this.members.length - 1]) this.members.pop();

        const minutes = this.lotteryTime;
        const lastLotteryTime = parseInt(localStorage.lotteryTime);
        if (
          !lastLotteryTime ||
          !this.lotteryStarted ||
          minutes * 60000 !== lastLotteryTime
        ) {
          this.lotteryStarted = true;
          localStorage.lotteryTime = minutes * 60000; // Timestamp value
          this.updateLotteryTime();
        }
        localStorage.members = JSON.stringify(this.members);
        this.updateTimer();
        this.configuringLottery = false;
      }
    },
    updateTimer() {
      const nextLotteryTime = parseInt(localStorage.nextLotteryTime);
      const currentTime = Date.now();
      this.timeLeft = Math.floor((nextLotteryTime - currentTime) / 1000);
      this.timerKey++;
    },
    timeIsUp() {
      const key = Math.floor(Math.random() * 100) + 1;
      this.newMemberLotteryDrawn(key);
      this.updateLotteryTime();
      const nextLotteryTime = localStorage.nextLotteryTime;
      this.updateTimer();
    },
    validateLotteryConfigFields() {
      if (!this.lotteryTime) {
        this.notifyVue(
          "bottom",
          "center",
          this.$t("lottery.configPage.validateLotteryTime"),
          "danger"
        );
        return false;
      } else if (this.members.length < 2) {
        this.notifyVue(
          "bottom",
          "center",
          this.$t("lottery.configPage.validateMemberList"),
          "danger"
        );
        return false;
      }
      return true;
    },
  },
};
</script>

<style>
.title {
  text-align: center;
}
.description {
  text-align: left;
}

.center {
  justify-content: center;
  display: grid;
}
</style>
